import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';

import PropTypes from 'prop-types';

import 'jsoneditor-react/es/editor.min.css';
import { propTypes } from 'formsy-react';

const JsonEditor = dynamic(
  async () => {
    // eslint-disable-next-line no-shadow
    const { JsonEditor } = await import('jsoneditor-react');
    // we need a custom component here to force the forward ref to actually work
    const JSONEDITOR = ({ forwardedRef, ...props }) => (
      <JsonEditor ref={forwardedRef} {...props} />
    );
    return JSONEDITOR;
  },
  {
    ssr: false,
  },
);
// we need to forward the ref because its a dynamic import
const ForwardedJsonEditor = React.forwardRef((props, forwardedRef) => (
  <JsonEditor {...props} forwardedRef={forwardedRef} />
));

function JsonInput({ value, onChange, allowedModes, name, readonly, style }) {
  const jsonEditorRef = React.createRef();
  useEffect(() => {
    const editor =
      jsonEditorRef &&
      jsonEditorRef.current &&
      jsonEditorRef.current.jsonEditor;
    if (editor && value) {
      editor.update(value);
    }
  }, [jsonEditorRef, value]);

  const mode = readonly ? 'view' : 'text';

  const handleChange = newValue => onChange(name, newValue);
  return (
    <ForwardedJsonEditor
      ref={jsonEditorRef}
      value={value}
      onChange={handleChange}
      mode={mode}
      allowedModes={allowedModes}
      htmlElementProps={{ style }}
    />
  );
}

JsonInput.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]).isRequired,
  style: propTypes.object,
  onChange: PropTypes.func,
  allowedModes: PropTypes.array,
  name: PropTypes.string,
  readonly: PropTypes.bool,
};

JsonInput.defaultProps = {
  value: {},
  readonly: false,
  allowedModes: ['view'],
  style: null,
};

export default JsonInput;
